
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/container-queries",
      function () {
        return require("private-next-pages/material-ui/customization/container-queries.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/container-queries"])
      });
    }
  